import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { getResponse } from "../../../helpers/api_helper";
import "../../pages.scss";
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

class Base64Decode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      respData: [],
      respErrorData: [],
      items: [],
      inputText: "",
      buttonTimer: false,
      histjson: [],
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleResetForm = this.handleResetForm.bind(this);
    this.addFailItem = this.addFailItem.bind(this);
    this.addSuccessItem = this.addSuccessItem.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleValidSubmit = (event) => {
    event.preventDefault();
    this.setState({ buttonTimer: true });

    const { inputText } = this.state;
    debugger

    const cloudInput = { data: inputText };
    getResponse(cloudInput, "/cloud/v1/Base64/Decode")
      .then((resp) => {
        this.setState({ buttonTimer: false });

        if (resp.resultCode !== "-1" && resp.resultCode !== undefined) {
          this.setState({ respData: [resp.resultData] });
          const dnm = JSON.parse(localStorage.getItem("jsonHistory"));

          if (dnm != null && dnm != 0) {
            this.setState({ histjson: JSON.parse(localStorage.getItem("jsonHistory")) });
            const a = [...this.state.histjson];
            a.push(resp);
            localStorage.setItem("jsonHistory", JSON.stringify(a));
          } else {
            localStorage.setItem("jsonHistory", JSON.stringify([resp]));
          }

          this.addSuccessItem();
        }
        else {
          this.setState({ respErrorData: [resp.resultDesc] });
          const dnm = JSON.parse(localStorage.getItem("jsonHistory"));

          if (dnm != null && dnm != 0) {
            this.setState({ histjson: JSON.parse(localStorage.getItem("jsonHistory")) });
            const a = [...this.state.histjson];
            a.push(resp);
            localStorage.setItem("jsonHistory", JSON.stringify(a));
          } else {
            localStorage.setItem("jsonHistory", JSON.stringify([resp]));
          }

          this.addFailItem();
        }
      })
  }


  handleResetForm = () => {
    this.form && this.form.reset();
  };

  addSuccessItem = () => {
    this.setState({ items: [] });
    this.setState((prevState) => ({
      items: [
        ...prevState.items,
        <Col key={Date.now()}>
          <Card>
            <CardBody>
              <Alert className="alert-success" role="alert">
                <h4 className="alert-heading">{this.props.t("Base64DecodeSearchOperationSuccess")}</h4>
                <hr />
                <div className="display-linebreak">{this.state.respData}</div>
              </Alert>
            </CardBody>
          </Card>
        </Col>
      ]
    }));
  };

  addFailItem = () => {
    this.setState({ items: [] });
    this.setState((prevState) => ({
      items: [
        ...prevState.items,
        <Col key={Date.now()}>
          <Card>
            <CardBody>
              <Alert className="alert-danger" role="alert">
                <h4 className="alert-heading">{this.props.t("Base64DecodeSearchOperationFail")}</h4>
                <hr />
                <div className="display-linebreak">{this.state.respErrorData}</div>
              </Alert>
            </CardBody>
          </Card>
        </Col>,
      ],
    }));
  };
  handleInputChange(event) {
    this.setState({ inputText: event.target.value });
  }
  handleClear = () => {
    this.setState({ inputText: "", respData: [], respErrorData: [] });
  };

  render() {
    const { inputText } = this.state;
    const defaultValues = { searchOption: "0" }
    return (
      <React.Fragment>
        <div className="page-content">
          <Helmet>

            <MetaTags>
              <title>Wechip - Wechip Payment Tools | {this.props.t("Base64D")}</title>
              <meta name="description" content="Base64 decode refers to decoding text or data into Base64 format. Explore the principles and techniques behind Base64 encoding, its applications, and its significance in data transmission." />
              <meta name="keywords" content="Base64 decode, data decoding, secure data transmission, Base64 format" />
            </MetaTags>
          </Helmet>
          <Container fluid>
            <Breadcrumbs title={this.props.t("Base64")} breadcrumbItem={this.props.t("Base64Decode")} />
            <Row>
              <Col md={6}>
                <Card>
                  <CardBody>
                    <AvForm onValidSubmit={this.handleValidSubmit} model={defaultValues}>
                      <Row className="rowAes">
                        <Col className="mb-3">
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label htmlFor="inputText">{this.props.t("inputText")}</Label>
                            <UncontrolledTooltip placement="bottom" target="inputText">
                              {this.props.t("inputTextInfo")}
                            </UncontrolledTooltip>
                            <AvField
                              name="inputText"
                              placeholder={this.props.t("fill")}
                              type="text"
                              value={inputText}
                              onChange={this.handleInputChange}
                              validate={{
                                required: { value: true },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <div className="d-flex flex-wrap gap-2" style={{ paddingTop: 6 }}>
                        <Button
                          color="secondary"
                          onClick={() => window.location.reload()}
                          style={{ textAlign: "start" }}
                          className="buttonDecode"
                        >
                          {this.props.t("clearButton")}
                        </Button>
                        <Button
                          type="submit"
                          disabled={this.state.buttonTimer}
                          color="primary"
                        >

                          {this.props.t("Decode")}
                        </Button>
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="6" >
                <Card className="scroll-col">
                  {this.state.items.slice().reverse()}
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Base64Decode.propTypes = {
  t: PropTypes.any,
};


export default (withTranslation()(Base64Decode));

